import { Route, Switch, useRouteMatch } from 'react-router-dom';
import { MassActionResolver } from './mass-action';
import { ProductsResolver } from './products-resolver';

export function ProductsRoutes() {
  const { path } = useRouteMatch();
  return (
    <Switch>
      <Route path={path} exact>
        <ProductsResolver />
      </Route>
      <Route path={`${path}/mass-action`}>
        <MassActionResolver />
      </Route>
    </Switch>
  );
}
